import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import Button from 'react-bootstrap/Button'
import Lang from '../../lang/translations';
import Context from '../../context/context';
import helpers from '../../_helpers/helpersFunction';
import { GTMEvents } from '../../_helpers/gtm/gtm';
const config = require("../../_helpers/configServizi");

import './css/promo_offer.css';

export default function PromoOffer(props) {

    const context = useContext(Context)

    const [spinner, setSpinner] = useState(false);

    useEffect(() => {
        console.log("dentro promo offer", props)

    }, []);


    async function tryCharge(rateplan) {
         const d = new Date();
        const domain = window.location.hostname;
        const data = {
            actonfile:true,
            clickid : localStorage.getItem("trackerId"),
            payment_company : config.servizi[domain].payment_company,
            language:navigator.language,
            screenHeight:window.screen.height,
            screenWidth: window.screen.width,
            timezone:d.getTimezoneOffset(),
            userAgent: navigator.userAgent,
            javaEnabled: true,
            javascriptEnabled: true,
            screenColorDepth:window.screen.colorDepth,
            country : helpers.getCountry(),
            rateplan: props.contenuto.promo[0],
            descriptor : config.servizi[domain].descriptor,
            city : localStorage.getItem("city"),
            domain : domain,
            email : context.email
        }
        setSpinner(true)
        helpers.logToBackend("Tentativo Pagamento",{pixel:true,clickid:localStorage.getItem('trackerId'),et:"tentativo"})

        GTMEvents.add_payment_info(localStorage.getItem("trackerId"),context.email,window.location.hostname)
        const response = await helpers.tryCharge(data)

        if (response.status == "ko") {
            if (response.message == "avoid_duplicate_transaction") {
                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                helpers.showPopupgenerico("blocked", context, contenuto)
            }
            context.setRateplanScelto(rateplan)
            navigate({ pathname: '/purchase/pay' });
        }

        if (response.status == "open") {
            if (response.redirect) {
                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                //elimino la chiave bottoni da contenuto
                delete contenuto.bottoni
                setSpinner(false)
                helpers.showPopupgenerico("blocked", context, contenuto)
                setTimeout(function () { window.location.replace(response.redirect) }, 4000);
                return
            }
            const contenuto = helpers.contenuto_popop_pagamento(response.message)
            setSpinner(false)
            helpers.showPopupgenerico("blocked", context, contenuto)

        }

        if (response.status == "ok") {

            if (response.threeDS) {
                //---- PROCEDURA PER 3DS
                console.log("procedura 3DS", response, response.threeDS)
                procedura3DS(response)
                return

            } else {

                const credMsg = context.creditiMessaggi + data.rateplan.crediti
                context.setCreditiMessaggi(credMsg)
                context.setCustomerId(response.data.customerId)
                context.setValoreMessaggio(context.flusso.valoreMessaggio)
                context.setActonfile(true)
                context.setNewCard(false)

                //--- se ho una promo tipo pacchettone la mostro, altrimenti vado avanti con popup standard
                if (response.promo && response.promo.length > 0) {
                    console.log("ho promo", response.promo)
                    var contenuto_promo = helpers.contenuto_popop_pagamento("promo")
                    contenuto_promo.promo = response.promo
                    setSpinner(false)
                    console.log("PACCHETTONE OK", contenuto_promo)
                    helpers.showPopupgenerico("ok_with_promo", context, contenuto_promo)
                    return
                }


                const contenuto = helpers.contenuto_popop_pagamento(response.message)
                setSpinner(false)
                helpers.showPopupgenerico("blocked", context, contenuto)


                setTimeout(function () {
                    context.Socket.emit('chat', context.messaggioPending);
                    context.setMessaggioPending(null);
                    window.location.replace("/chats")
                }, 6000);
            }

        }


    }

    function Spinner(){
    
            if(spinner){
              return (<div className="waiterAdattivo">
                  <div className="spinner-adattivo" role="status">
              <span className="sr-only"></span>
              
            </div>
            <div className="testoSpinner">
                  <Lang w={"aggiungiamo_crediti"} page={"pianiAbbonamento"}/>
            </div>
          
            </div>);
            }return false
          }


    return (<> <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen={true}
        backdrop="static"
        dialogClassName="popupgenerico popup-promo-special"
        animation={false}
        onHide={() => { window.location.replace(props.contenuto.redirect) }}
    >
        <Spinner />
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
            
            {props.contenuto.titolo && (
                <h3 className="titolo_popup_generico">{props.contenuto.titolo}</h3>
            )}

            <p style={{ textAlign: "center"}}
                dangerouslySetInnerHTML={{ __html: props.contenuto.messaggio }}></p>


            {/* 🆕 TABELLA OFFERTA SPECIALE */}
           
            <div className="promo-offer-container">
                <div className="promo-offer-badge">
                 
                    {props.contenuto.prendine_un_altro && (
                        <div className="offer-badge-text">
                            {props.contenuto.prendine_un_altro}
                        </div>
                    )}
                </div>

                {/* ciclo per mostrare i dettagli dell'offerta */}
                {props.contenuto.promo.map(function (data, index) {
                    
                    return (<div className="promo-offer-table" key={index}>
                        <div className="promo-offer-cell promo-credits">
                            <div className="credits-amount">
                                {data.crediti}
                                <span className="coins-icon">💰</span>
                            </div>
                            <div className="credits-label"><Lang w={"crediti"} page={"pianiAbbonamento"} /></div>
                        </div>

                        <div className="promo-offer-cell promo-price">
                            <div className="old-price">{data.vecchioPrezzo}</div>
                            <div className="new-price">{data.prezzo}</div>
                        </div>
                    </div>)
                })}

                <div className="promo-offer-cta">
                    <Lang w={"approfitta_ora"} page={"pianiAbbonamento"} />
                </div>
            </div>
            

        </Modal.Body>

        <Modal.Footer>
            {props.contenuto.bottoni && props.contenuto.bottoni.map(function (data, index) {
                return data.redirect ? (
                    <Button
                        key={index}
                        style={{ width: "100%" }}
                        onClick={() => {
                            navigate({ pathname: data.redirect });
                            if (data.onclick) {
                                console.log(data.onclick);
                                eval(data.onclick)
                            }
                            props.onHide();
                        }}
                    >
                        <i className={data.icona} /> {data.testo}
                    </Button>
                ) : (
                    <Button
                        key={index}
                        onClick={() => { tryCharge() }}
                    >
                        <i className={data.icona} /> {data.testo}
                    </Button>
                )
            })}
        </Modal.Footer>
    </Modal> </>);

}